angular
    .module('quattro.bmbo.domain.model', [
        'quattro.core.model.prototype',
        'quattro.core.hpls_api_1',
    ])
    .factory('Domain', function ($log, $q, api, Model) {

        var prototype = Model.prototype;
        Domain.possible_capabilities = ["MAIL_BLACKLIST", "MAIL_SPAMPROTECTION", "MAIL_BACKUPRECOVER", "MAIL_PASSWORDRESET_SMS"];

        function getDefaultData() {
            return {
                domain: undefined,

                status: undefined,
                context_id: undefined,
                date_register: undefined,
                password: undefined,
                memo: undefined,
                capabilities: undefined,
                plansavailable: undefined,
            };
        }

        var authorization = {
            read: 'all',
            create: ['admin', 'account'],
            update: {
                default: ['admin', 'account'],
                attributes: {}
            },
            remove: ['admin', 'account'],
        };


        var scenarios = {
            read: [
                {
                    method: 'domain.get',
                    params: {
                        'domain': {
                            primary_key: true,
                        },
                    },
                    results: {
                        domain: null,
                        status: null,
                        context_id: null,
                        date_register: null,
                        memo: null,
                        plansavailable: null
                    }
                }
            ],
            create: [
                {
                    method: 'domain.add',
                    params: {
                        account: {
                            primary_key: true,
                        },
                        domain: {
                            required: true,
                        },
                        password: {
                            required: true,
                        },
                        context_id: null,
                        create_new_context_id: null,
                        memo: null,
                    }
                }
            ],
            update: [
                {
                    method: 'domain.set',
                    params: {
                        domain: {
                            primary_key: true,
                        },
                        password: null,
                        memo: null,
                        context_id: null,
                        create_new_context_id: null,
                    },
                },
                {
                    method: 'domain.capabilities.set',
                    params: {
                        domain: {
                            primary_key: true,
                        },
                        capabilities: {},
                    },
                },
            ],
            remove: [
                {
                    method: 'domain.del',
                    params: {
                        account: {
                            primary_key: true,
                        },
                        domain: {
                            primary_key: true,
                        },
                    },
                },
            ],
        };


        function query(account) {
            return api.single('domain.list', {
                account: account,
            }).then(function (result) {
                result.forEach(function (domain) {
                    domain.account = account;
                });
                return $q.when(result);
            }, function (error) {
                $log.error('domain.list', error.code, error.message);
                return $q.reject(error);
            });
        }


        function Domain(config, scenario) {
            this.scenario = scenario;
            var data = scenario === 'create' ? getDefaultData() : {};
            this.data = angular.merge(data, config);
            this.data.$validate = this.validate.bind(this);
            this.data.$isDirty = this.isDirty.bind(this);
        }

        // static
        Domain.query = query;

        Domain.prototype = angular.merge(new Model(), {
            scenarios: scenarios,
            authorization: authorization,
        });

        return Domain;
    });
